export default __webpack_public_path__ + "static/media/tel-icon.4a7d97c6.svg";